// extracted by mini-css-extract-plugin
export default {"card":"Card_card__l6imy","title":"Card_title__KVM1Z","desc":"Card_desc__ErqGe"};